import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { MenuAndContent } from 'app/components/layouts';
import { EquipmentNotLoaded } from 'app/pages/Equipment/EquipmentNotLoaded';
import React from 'react';
import { Outlet } from 'react-router-dom';

interface Props {
  useTheEntireSpace?: boolean;
}

export default function EquipmentLoadingGuard({ useTheEntireSpace }: Props) {
  const { equipmentListData } = React.useContext(EquipmentListContext);

  const renderIfEquipmentLoaded = (comp: JSX.Element) => {
    return equipmentListData?.equipmentList ? (
      comp
    ) : (
      <MenuAndContent>
        <EquipmentNotLoaded />
      </MenuAndContent>
    );
  };

  return renderIfEquipmentLoaded(
    <MenuAndContent useTheEntireSpace={useTheEntireSpace}>
      <Outlet />
    </MenuAndContent>,
  );
}
